import { computed } from 'vue';
import { IFilterProvider } from "@/interfaces/filter-providers/IFilterProvider";
import { ILocationFilterProvider } from "@/interfaces/filter-providers/ILocationFilterProvider";
import { FilterKey } from '@/models/FilterKey';
import { CountryFilterOptionInformation } from '@/models/CountryFilterOptionInformation';

export class PopularCountries {
	private readonly topCountries: string[] = [];

	public constructor(
		private readonly filterProvider: IFilterProvider,
		locationFilterProvider: ILocationFilterProvider,
	) {
		this.topCountries = locationFilterProvider.identifyTopCountries();
	}

	public value = computed(() => {
		const selectedCountries = this.filterProvider.getFilterSelection(FilterKey.COUNTRY);
		const popularCountriesToDisplay = this.topCountries.filter(item => !selectedCountries.includes(item));
		return this.getCountryInformationFor(popularCountriesToDisplay);
	});

	private getCountryInformationFor(countryIds: string[]): CountryFilterOptionInformation[] {
		const options: CountryFilterOptionInformation[] = [];

		countryIds.forEach((countryId) => {
			const filterOptionInformation = this.filterProvider.getFilterOptionInformationById(FilterKey.COUNTRY, countryId);
			if (filterOptionInformation != null) {
				options.push(filterOptionInformation as CountryFilterOptionInformation);
			}
		});

		return options;
	}
}
